import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { Search } from "lucide-react";

export default function PowerOutage() {
  const navigate = useNavigate();
  
  const [outages, setOutages] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('https://poweroutage-vbnbnaa5aq-uc.a.run.app')
      .then(res => setOutages(res.data.outages))
      .catch(err => {
        console.error(err);
        setOutages([]);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-white border border-halloween-orange/30 shadow-halloween-purple/10 rounded-lg p-4 shadow-sm">
      <h2 className="text-lg font-bold mb-4 flex items-center gap-2">
        Lịch cúp điện Nhơn Trạch
      </h2>
      {loading ? (
        <p className="text-gray-500">Đang tải...</p>
      ) : outages.length === 0 ? (
        <p className="text-green-600 font-medium">✅ Hôm nay không có lịch cúp điện!</p>
      ) : (
        <ul className="space-y-4 text-sm">
          {outages.map((o, idx) => (
            <li key={idx} className="bg-yellow-50 border border-yellow-200 rounded-md p-3 shadow-sm">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-yellow-600 font-semibold">⏰</span>
                <span className="text-gray-800">{o.start} → {o.end}</span>
              </div>
              <div className="flex items-center gap-2 mb-1">
                <span className="text-yellow-600 font-semibold">📍</span>
                <span className="text-gray-800">{o.location}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-yellow-600 font-semibold">❗</span>
                <span className="text-gray-800">{o.reason}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
      <div className="flex justify-center">
        <button
          style={{ backgroundColor: "#3F6033" }}
          className="hover:opacity-90 text-white px-3 py-1 mt-4 rounded flex items-center gap-2"
          onClick={() => navigate("/outage_check")}
        >
          <Search size={16} />
          Tra cứu theo MKH
        </button>
      </div>
    </div>

  );
}
